import styled from 'foundations-theming/utils';
import I18n from 'I18n';
import PlaylistThumbnailImage from './PlaylistThumbnailImage';
import PlaylistThumbnailOverlay from './PlaylistThumbnailOverlay';
import { useCanUserEditPlaylist } from 'academy-common-lib/features/savedItems/savedItemsHooks';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const ThumbnailContainer = styled.div.withConfig({
  displayName: "PlaylistThumbnail__ThumbnailContainer"
})(["position:relative;border-radius:", ";aspect-ratio:16 / 9;overflow:hidden;"], ({
  theme
}) => theme.borderRadius['400']);
const PlaylistThumbnail = ({
  playlist,
  onAddContent
}) => {
  const canUserEditPlaylist = useCanUserEditPlaylist(playlist.id);
  const hasThumbnail = !!playlist.previewThumbnailRectangleUrl;
  if (!canUserEditPlaylist && !hasThumbnail) {
    return null;
  }
  return (
    /*#__PURE__*/
    // @bend-expect trellis-tokenized
    _jsxs(ThumbnailContainer, {
      "data-test-id": "playlist-thumbnail-container",
      children: [/*#__PURE__*/_jsx(PlaylistThumbnailImage, {
        alt: I18n.text('academyCommon.contentCard.thumbnailAlt', {
          title: playlist.name
        }),
        isOwnedByUser: !!canUserEditPlaylist,
        src: playlist.previewThumbnailRectangleUrl
      }), /*#__PURE__*/_jsx(PlaylistThumbnailOverlay, {
        onAddContent: onAddContent,
        playlist: playlist
      })]
    })
  );
};
export default PlaylistThumbnail;